import React,{ Component } from "react";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import { getServers} from "../../../actions/actionServer";
import { Row, Col, Table, Card, CardBody, CardHeader, Button} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import moment from "moment";
import ReactJson from 'react-json-view';
import { Progress } from 'reactstrap';

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Agent",path:"/agents",isActive: false},
    {name: "ViewAgent",path:"/viewagent",isActive: true},
];

class ViewServer extends Component{
    constructor(props){
        super(props);
        this.state = {
            currentServer: null
        };
    }
  
    componentDidMount(){
        this.props.getServers();
    }
      
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.servers.length > 0){        	
            let currentServer = nextProps.servers.find(server => server.server_id === this.props.match.params.id);
            this.setState({currentServer: currentServer});
        }
    }

    formatSizeUnits(bytes){
      if      (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
      else if (bytes >= 1048576)    { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
      else if (bytes >= 1024)       { bytes = (bytes / 1024).toFixed(2) + " KB"; }
      else if (bytes > 1)           { bytes = bytes + " bytes"; }
      else if (bytes == 1)          { bytes = bytes + " byte"; }
      else                          { bytes = "0 bytes"; }
      return bytes;
    }

    render(){
        const {currentServer} = this.state;
        return (
            <div>  
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>View Agent</strong>
                                {currentServer ? <Link className="pull-right" to={{ pathname: `/updateagent/${currentServer.server_id}`}}>
                                    <Button size="sm" color="dark"> Edit Agent </Button> </Link> : " " }
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        {currentServer?
                                            <div>
                                                <div className="text-left"><div className={currentServer.cpu_percent < 80 ? "box green":"box red"}></div>Core Utilization: <b>{currentServer.cpu_percent}% </b></div>
                                                <div className="text-left"><div className="box blue"></div>Core Allocation: <b>{Math.round(currentServer.core_calculations.percentage)}%  ({currentServer.core_calculations.used} of {currentServer.core_calculations.max} Cores) </b></div>
                                                {currentServer.cpu_percent < currentServer.core_calculations.percentage ?
                                                    (<Progress multi>
                                                        <Progress striped bar color={currentServer.cpu_percent < 80 ? "success":"danger"} value={currentServer.cpu_percent} />
                                                        <Progress striped bar color="info" value={currentServer.core_calculations.percentage - currentServer.cpu_percent} />
                                                    </Progress>)
                                                    :
                                                    (<Progress multi>
                                                        <Progress striped bar color="info" value={currentServer.core_calculations.percentage} />
                                                        <Progress striped bar color={currentServer.cpu_percent < 80 ? "success":"danger"} value={currentServer.cpu_percent - currentServer.core_calculations.percentage} />
                                                    </Progress>)}

                                                <div className="text-left"><div className={currentServer.memory_stats.percent < 80 ? "box green":"box red"}></div>Memory Utilization: <b>{currentServer.memory_stats.percent}% </b></div>
                                                <div className="text-left"><div className="box blue"></div>Memory Allocation: <b>{Math.round(currentServer.memory_calculations.percentage)}% ({this.formatSizeUnits(currentServer.memory_calculations.used)} of {this.formatSizeUnits(currentServer.memory_calculations.max)})</b></div>
                                                {currentServer.memory_stats.percent < currentServer.memory_calculations.percentage ?
                                                    (<Progress multi>
                                                        <Progress striped bar color={currentServer.memory_stats.percent < 80 ? "success":"danger"} value={currentServer.memory_stats.percent} />
                                                        <Progress striped bar color="info" value={currentServer.memory_calculations.percentage - currentServer.memory_stats.percent}/>
                                                    </Progress>)
                                                    :
                                                    (<Progress multi>
                                                        <Progress striped bar color="info" value={currentServer.memory_calculations.percentage} />
                                                        <Progress striped bar color={currentServer.memory_stats.percent < 80 ? "success":"danger"} value={currentServer.memory_stats.percent - currentServer.memory_calculations.percentage}/>
                                                    </Progress>)}

                                                <div className="text-left">Disk Usage: <b>{currentServer.disk_stats.percent}% </b></div>
                                                  <Progress striped color={currentServer.disk_stats.percent > 80 ? "danger" : "info"} value={currentServer.disk_stats.percent}></Progress>
                                                <br/>
                                            </div> :" "}
                                        <div>
                                            {currentServer?
                                                <Table bordered>
                                                    <tbody>
                                                        <tr><td>Agent Id</td><td>{currentServer.server_id}</td></tr>
                                                        <tr><td>Hostname</td><td>{currentServer.hostname}</td></tr>
                                                        <tr><td>Enabled</td><td>{currentServer.enabled ? "True": "False"}</td></tr>
                                                        <tr><td>Manager</td><td>{currentServer.manager ? currentServer.manager.manager_hostname : ""}</td></tr>
                                                        <tr><td>Zone</td><td>{currentServer.manager ? currentServer.manager.zone_name : ""}</td></tr>
                                                        <tr><td>Version</td><td>{currentServer.agent_version}</td></tr>
                                                        <tr><td>Provider</td><td>{currentServer.provider}</td></tr>
                                                        <tr><td>Instance Id</td><td>{currentServer.instance_id}</td></tr>
                                                        <tr><td>Last Reported</td><td>{currentServer.last_reported_elapsed}</td></tr>
                                                        <tr><td>Last Reported Time</td><td>{moment(currentServer.last_reported).format("L h:mm A")}</td></tr>
                                                        <tr><td>Operational Status</td><td>{currentServer.operational_status}</td></tr>
                                                        <tr><td>CPU Cores</td><td>{currentServer.cores}</td></tr>
                                                        <tr><td>CPU Cores Override</td><td>{currentServer.cores_override}</td></tr>
                                                        <tr><td>Memory</td><td>{currentServer.memory}</td></tr>
                                                        <tr><td>Memory Override</td><td>{currentServer.memory_override}</td></tr>
                                                        <tr><td>Memory Stats</td><td className="word-wrap"><ReactJson src={currentServer.memory_stats}
                                                            name={false}
                                                            collapsed={true}
                                                            sortKeys={true}
                                                            collapseStringsAfterLength={40}
                                                            enableClipboard={false}
                                                            displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td>Network Interfaces</td><td className="word-wrap"><ReactJson src={currentServer.network_interfaces}
                                                            name={false}
                                                            collapsed={true}
                                                            sortKeys={true}
                                                            collapseStringsAfterLength={40}
                                                            enableClipboard={false}
                                                            displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td>Disk Stats</td><td className="word-wrap"><ReactJson src={currentServer.disk_stats}
                                                            name={false}
                                                            collapsed={true}
                                                            sortKeys={true}
                                                            collapseStringsAfterLength={40}
                                                            enableClipboard={false}
                                                            displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td>Live Kasms</td><td className="word-wrap"><ReactJson src={currentServer.kasms}
                                                            name={false}
                                                            collapsed={true}
                                                            sortKeys={true}
                                                            collapseStringsAfterLength={40}
                                                            enableClipboard={false}
                                                            displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td>Docker Images</td><td className="word-wrap"><ReactJson src={currentServer.docker_images}
                                                            name={false}
                                                            collapsed={true}
                                                            sortKeys={true}
                                                            collapseStringsAfterLength={40}
                                                            enableClipboard={false}
                                                            displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td>Docker Info</td><td className="word-wrap"><ReactJson src={currentServer.docker_info}
                                                            name={false}
                                                            collapsed={true}
                                                            sortKeys={true}
                                                            collapseStringsAfterLength={40}
                                                            enableClipboard={false}
                                                            displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td>Manager Details</td><td className="word-wrap"><ReactJson src={currentServer.manager}
                                                            name={false}
                                                            collapsed={true}
                                                            sortKeys={true}
                                                            collapseStringsAfterLength={40}
                                                            enableClipboard={false}
                                                            displayDataTypes={false}
                                                        /></td></tr>
                                                    </tbody>
                                                </Table> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>   
                    </Col>
                </Row>
            </div>
        );}
}

ViewServer.propTypes = {
    getServers: Proptypes.func.isRequired,
    servers: Proptypes.array,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        servers: state.servers.servers || []
    }),
dispatch => 
    ({  
        getServers: () => dispatch(getServers()),
    }))(ViewServer);



// WEBPACK FOOTER //
// ./src/views/Agents/ViewAgent/ViewServer.js